import { Form, type FormInstance } from "antd";
import FileUpload from "../../../../components/FileUpload";

type Props = {
  form: FormInstance<any>;
};

export default function CvInfo({ form }: Props) {
  // CV info
  return (
    <Form.Item
      name="cvFileUrl"
      label="সিভি আপলোড করুন"
      className="mb-4"
      rules={[
        {
          required: true,
          message: "সিভি আপলোড করুন",
        },
      ]}
    >
      <FileUpload form={form} accept=".png,.jpg,.jpeg,.pdf" name="cvFileUrl" />
    </Form.Item>
  );
}
